import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ContactFormModal from './ContactFormModal';
import { analyticsTrack } from '../../analyticsUtils';
import './ContactSupportBanner.scss';
var handleAddProject = function handleAddProject() {
  analyticsTrack('Clicked Add Project on search banner', {
    location: 'Search Index'
  });
  window.location.href = '/projects/add_project';
};
function ContactSupportBanner(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "support-hero"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-hand-point-right mr-12"
  }), "Looking for a different expertise?"), ' ', "Clora's Operations team can assist you with any functional need.", /*#__PURE__*/React.createElement("span", {
    className: "btn-group"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary btn-project",
    onClick: handleAddProject
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }), "Add Project"), /*#__PURE__*/React.createElement(ContactFormModal, props))));
}
ContactSupportBanner.propTypes = {
  csrfToken: PropTypes.string.isRequired
};
export default ContactSupportBanner;